module.exports = {
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_PUBLIC_KEY,
    mailChimpKey: process.env.REACT_APP_MAIL_CHIMP_ENDPOINT,
}